/** Minimum time the loader stays visible (ms). */
const MIN_DISPLAY_MS = 3000;

/** Maximum time before the loader is dismissed regardless (ms). */
const MAX_DISPLAY_MS = 5500;

/** How often to check whether the Tally widget has rendered (ms). */
const POLL_INTERVAL_MS = 150;

/** Selectors that indicate the Tally sticker quoter is ready. */
const TALLY_READY_SELECTORS = [
  'iframe[src*="tallyprint"]',
  'iframe[src*="tally"]',
  '[id*="tally_auto_sticker"]',
  '[id*="tally_quoter"]',
  '[class*="tally-quoter"]',
  '[class*="TallyQuoter"]',
];

/**
 * @returns {boolean}
 */
function isTallyWidgetReady() {
  if (TALLY_READY_SELECTORS.some((selector) => document.querySelector(selector))) {
    return true;
  }

  const appBlocks = document.querySelectorAll('.shopify-app-block');

  for (const block of appBlocks) {
    if (!(block instanceof HTMLElement)) continue;

    const hasInteractiveChild = block.querySelector(
      'iframe, canvas, button, [role="button"], input[type="file"]'
    );

    if (hasInteractiveChild && block.offsetHeight > 120) {
      return true;
    }
  }

  return false;
}

/**
 * @returns {boolean}
 */
function isThemeEditor() {
  return (
    document.documentElement.classList.contains('shopify-design-mode') ||
    window.Shopify?.designMode === true
  );
}

/**
 * @param {HTMLElement} loader
 */
function dismissLoader(loader) {
  loader.classList.add('is-hidden');
  loader.setAttribute('aria-busy', 'false');
  document.body.classList.remove('sticker-customizer-loader-active');

  loader.addEventListener(
    'transitionend',
    () => {
      loader.remove();
    },
    { once: true }
  );
}

function initStickerCustomizerLoader() {
  const loader = document.getElementById('sticker-customizer-loader');
  if (!(loader instanceof HTMLElement)) return;

  if (isThemeEditor()) {
    document.body.classList.remove('sticker-customizer-loader-active');
    loader.remove();
    return;
  }

  document.body.classList.add('sticker-customizer-loader-active');

  const startedAt = Date.now();
  let dismissed = false;

  const maybeDismiss = () => {
    if (dismissed) return true;

    const elapsed = Date.now() - startedAt;
    const tallyReady = isTallyWidgetReady();

    if ((elapsed >= MIN_DISPLAY_MS && tallyReady) || elapsed >= MAX_DISPLAY_MS) {
      dismissed = true;
      dismissLoader(loader);
      return true;
    }

    return false;
  };

  if (maybeDismiss()) return;

  const intervalId = window.setInterval(() => {
    if (maybeDismiss()) {
      window.clearInterval(intervalId);
    }
  }, POLL_INTERVAL_MS);

  const observer = new MutationObserver(() => {
    if (maybeDismiss()) {
      observer.disconnect();
      window.clearInterval(intervalId);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickerCustomizerLoader, { once: true });
} else {
  initStickerCustomizerLoader();
}
